import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TOURNEY_CHIP_CHAR } from '../../utils/currencyUtils';
import { AdminDot } from './adminDot';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ALL_EMOJI_SMILEYS_FONT_TYPES = ['smileys', 'smileystext'];
const ALL_EMOJI_REPLACEMENTS = {
    smileys: {
        '^': '✊',
        E: '🎵',
        D: '💣',
        c: '♣️',
        d: '♦️',
        h: '❤️',
        s: '♠️',
        '{f}': '😚', // was 'woman'
        '{W}': '😡', // mean
        '{r}': '😠', // mad
        '{k}': '😀', // smiley
        '{l}': '😞', // sad
        '{m}': '😐', // content
        '{n}': '😮', // shock
        '{o}': '😃', // wide smile
        '{p}': '😉', // wink
        '{q}': '😜', // tongue
        '{t}': '🤪', // slant 1
        '{u}': '🫤', // slant 2
        '{U}': '😴', // sleep
        '{V}': '😓', // cry
        '{X}': '😵', // dead
        '{Y}': '🙄', // was 'cyclops'
        '{R}': '🤯', // was 'pirate'
        '{B}': '🤓', // bucktooth
        '{i}': '😳', // wide-eyed
        '{g}': '😵‍💫', // perplexed
        z: '⚡️',
        N: '🤝', // friend
        '(': '(',
        ')': ')',
        '-': '-',
        '!': '⚠️', // warning
        ';': TOURNEY_CHIP_CHAR,
        "'": '💬',
        // '"': 'A',
        '&': '💰', // was 'amp'
        O: '💰', // was 'dollar'
        F: '🌙',
        Z: '💤',
        '#': '👏',
        '=': '🚪',
        G: '⏱',
        '"': _jsx(AdminDot, {}),
        $: '🌹',
        x: '⬆️'
    },
    smileystext: {
        $: '💰',
        '`': '🏅',
        '&': '🍷',
        '\\': '⬇️'
    }
};
export function getEmojiFromChildNode(childNode) {
    if (childNode.nodeName.toLowerCase() !== 'font') {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const face = childNode.face;
    const emojiReplacements = ALL_EMOJI_REPLACEMENTS[face];
    if (!emojiReplacements) {
        return;
    }
    if (childNode.childNodes.length !== 1) {
        return;
    }
    const innerNode = childNode.childNodes[0];
    if (innerNode.nodeName.toLowerCase() !== '#text') {
        return;
    }
    const innerValue = innerNode.nodeValue;
    if (!innerValue) {
        return;
    }
    return emojiReplacements[innerValue];
}
